import { render } from "./WaitActivation.vue?vue&type=template&id=48d750da"
import script from "./WaitActivation.vue?vue&type=script&lang=js"
export * from "./WaitActivation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__